exports.removeEmpty = function (
  objOrArray,
  onEmpty = {},
  unwantedValues = [undefined, null, ''],
  filterFn = null,
) {
  if (Array.isArray(objOrArray)) {
    let cleanArray = objOrArray.filter((n) => unwantedValues.indexOf(n) === -1)
    return cleanArray.length > 0 ? cleanArray : onEmpty
  } else if (typeof objOrArray === 'object') {
    // console.log('removeEmpty if case 3')
    let newObj = Object.fromEntries(
      Object.entries(objOrArray).filter(([_, v]) => {
        if (typeof filterFn === 'function') {
          // update here...
        } else if (unwantedValues.indexOf(v) !== -1) {
          // console.log('removeEmpty %s case 3.1', v)
          return false
        } else if (Array.isArray(v) && v.length < 1) {
          // console.log('removeEmpty %s case 3.2', v)
          return false
        } else if (v instanceof Date) {
          // console.log('removeEmpty %s case 3.3', v)
          return true
        } else if (typeof v === 'object' && Object.keys(v).length < 1) {
          // console.log('removeEmpty %s case 3.4', v)
          return false
        }
        return true
      }),
    )
    if (Object.keys(newObj).length < 1) {
      return onEmpty
    }
    return newObj
  } else {
    console.log(
      '!!! Unsupported var type for `removeNulls`. Type: %s',
      typeof objOrArray,
    )
    return objOrArray
  }
}
